module.exports = __webpack_public_path__ + "static/media/Basic-Host-NA-Partner.71c59944.png";